export default {
    // 起报时间
    forecastDate: '起报时间',
    // 模式选择
    mode: '模式',
    // 图层类型
    linearFillColor:'渐变',
    mask:'遮罩',
    gridData:'格点',
    seaLevelPressure:'气压',
    flowLine:'流线',
    gridWind:'风羽',
    // 高度场
    GPH:'高度场',
    undefined:'无定义',
    // 风场
    WIUV:'风场',
    wind:'风',
    // 预报时间间隔与预报时效
    dateInterval: '时间间隔',
    forecastTime: '预报时效',
    subjectiveForecast: '主观预报',

    // 菜单项
    situationField: '形势场',

    averageWindSpeed: '平均风风速',
    hourlyAverageWindSpeed: '整点',
    maxAverageWindSpeed12H:'12H最大',
    maxAverageWindSpeed24H:'24H最大',
    processMaxAverageWindSpeed:'过程最大',

    average10mWindSpeed: '平均10m风风速',
    hourlyAverage10mWindSpeed: '整点',
    maxAverage10mWindSpeed12H:'12H最大',
    maxAverage10mWindSpeed24H:'24H最大',
    processMaxAverage10mWindSpeed:'过程最大',


    gust10mWindSpeed: '10m阵风风速',
    hourlyGust10mWindSpeed: '整点',
    extremeGust10mWindSpeed12H:'12H极大',
    extremeGust10mWindSpeed24H:'24H极大',
    processExtremeGust10mWindSpeed:'过程极大',

    pressure24hChange:'气压 + 24h变压',
    temperature24hChange:'温度场 + 24h变温',

    precipitation: '降水',

    accumulated: '累积',
    
    convectivePrecipitation: '对流性降水',

    largeScalePrecipitation: '大尺度降水',

    specificHumidity: '比湿',
    relativeHumidity: '相对湿度',
    hourlyRelativeHumidity: '整点',
    maxRelativeHumidity: '最大',
    minRelativeHumidity: '最小',
    specificHumidity2m: '2m比湿',
    dewPoint2m: '2m露点',
    precipitableWater: '整层可降水量',
    divergence: '散度',

    verticalWindShear: '垂直风切变',

    pseudoEquivalentPotentialTemperature: '假相当位温',
    CAPE: '对流有效位能',
    KIndex: 'K指数',
    LCL: '抬升凝结高度',

    moistureFlux:'水汽通量',
    moistureFluxDivergence:'水汽通量散度',
    landSeaTemperatureDifference: '海陆温差',
    CIN: '对流抑制能量',
    
    temperature: '气温',

    temperature2m: '2m气温',
    hourlyTemperature2m: '整点',
    dailyMaxTemperature2m: '日最高',
    dailyMinTemperature2m: '日最低',

    dewPointTemperature2m: '2m露点气温',
    hourlyDewPointTemperature2m: '整点',
    dailyMaxDewPointTemperature2m: '日最高',
    dailyMinDewPointTemperature2m: '日最低',

    pressureChange24H: '24H变压',
    temperatureChange24H: '24H变温',
    temperatureAdvection: '温度平流',

    highCloudCover: '高云量',
    hourlyHighCloudCover: '整点',
    maxHighCloudCover24H: '24小时最大',

    mediumCloudCover: '中云量',
    hourlyMediumCloudCover: '整点',
    maxMediumCloudCover24H: '24小时最大',

    lowCloudCover: '低云量',
    hourlyLowCloudCover: '整点',
    maxLowCloudCover24H: '24小时最大',

    totalCloudCover: '总云量',
    hourlyTotalCloudCover: '整点',
    maxTotalCloudCover24H: '24小时最大',

    visibility: '能见度',
    hourlyVisibility: '整点',
    minVisibility: '最小能见度',

    seaSurfaceTemperature: '海温',

    severeConvection: '强对流',
    compositeReflectivity: '组合反射率',

    shadow: '阴影',
    isoline: '等值线',
    geopotentialHeightIsoline: '高度等值线',
    seaLevelPressureIsoline: '海平面气压等值线',
    currentModeNotAvailable: '当前模式无',

    longitude: '经度',
    latitude: '纬度',

    h:'时',
    hour:'小时',
  };

  export const zhMessages = {
    "situationField": "形势场",
    "precipitation": "降水",
    "temperature": "气温",
    "visibility": "能见度",
    "severeConvection": "强对流",
  }